export default "* Hvad kendetegner de fleste fisk?\n* Hvilken form kan en fisk have?\n* Hvordan kan en fisk kamuflere sig?";